/**
 * @generated SignedSource<<30f3f3ba094d82ad03eb035d1bcf2be1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type listPaginationQueryFragment$data = {
  readonly hasContent: boolean;
  readonly hasNext: boolean;
  readonly hasPrevious: boolean;
  readonly isFirst: boolean;
  readonly isLast: boolean;
  readonly pageNum: number;
  readonly pageSize: number;
  readonly sort: {
    readonly " $fragmentSpreads": FragmentRefs<"listPaginationQuerySortFragment">;
  };
  readonly totalElements: number;
  readonly totalPages: number;
  readonly " $fragmentType": "listPaginationQueryFragment";
};
export type listPaginationQueryFragment$key = {
  readonly " $data"?: listPaginationQueryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"listPaginationQueryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "listPaginationQueryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasContent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNext",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPrevious",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFirst",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLast",
      "storageKey": null
    },
    {
      "alias": "pageNum",
      "args": null,
      "kind": "ScalarField",
      "name": "number",
      "storageKey": null
    },
    {
      "alias": "pageSize",
      "args": null,
      "kind": "ScalarField",
      "name": "size",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Sort",
      "kind": "LinkedField",
      "name": "sort",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "listPaginationQuerySortFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalElements",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalPages",
      "storageKey": null
    }
  ],
  "type": "PageInfo",
  "abstractKey": null
};

(node as any).hash = "f08739bee36447230490f64851415a00";

export default node;
